import produce from 'immer'
import { assign, stubFalse } from 'lodash'

import { createSelectOptions } from '../../helpers'
import { COMMON_FETCH_ALLERGENS } from '../action-types'
import { ALLERGENS_INITIAL_STATE } from '../initial-states'

const allergensReducer = (state = ALLERGENS_INITIAL_STATE, action) => {
  switch (action.type) {
    case COMMON_FETCH_ALLERGENS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_ALLERGENS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.allergens.results,
          options: createSelectOptions(
            action.payload.data.allergens.results,
            'name',
            'id',
            stubFalse,
            ['includedAllergens', 'includedIngredients'],
          ),
        }),
      )

    case COMMON_FETCH_ALLERGENS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_ALLERGENS.CLEANUP:
      return { ...ALLERGENS_INITIAL_STATE }

    default:
      return state
  }
}

export default allergensReducer
